export default __webpack_public_path__ + "static/moneybus_cover-big_1-989e5a2876d89fb27f7004eba0620334.webp";